import RouterView from "@/views/RouterView";
import ListeRequeteView from "@/views/requete/ListeRequeteView";
import FicheRequeteView from "@/views/requete/FicheRequeteView";
import MesRequetesView from "@/views/MesRequetes";
import { authentified } from "./AccesDecisions";
import {  LISTE_REQUETE, ONGLET_DETAIL, MES_REQUETES } from "./requetes";
export default [{
    path: "/requete",
    component: RouterView,
    children: [
        {
            path: "",
            name: MES_REQUETES,
            component: MesRequetesView,
            meta: {
                auth: authentified()
            }
        },
        {
            path: "toutes",
            name: LISTE_REQUETE,
            component: ListeRequeteView,
            meta: {
                auth: authentified()
            }
        },
        {
            path: "detail/:numero",
            name: ONGLET_DETAIL,
            component: FicheRequeteView,
            props: true,
            meta: {
                auth: authentified()
            }
        },
    ],
}]
